import PayzenInit from './PayzenInit';
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { formatPriceWithEuro, getUserEmail } from '../../utils/StringUtils';
import { useCheckout } from '../../context/checkoutProvider';
import dell from '../../styles/img/dell.svg';
import { successPaidOrder } from '../../actions/cartActions';
import { addUsedPromo, updatePayzenCards } from '../../actions/userActions';
import { sentryPspError } from '../../utils/sentry';
import useAxios
 from '../../axios/useAxios';
import { calculateTotalToPay } from '../../utils/order/orderUtils';

const PayzenPayments = (
  {
    setApplepayTRpopup,
    order,
    errorMessage,
    promoLoaded,
    setPayzenToken,
    onCheckboxChange,
    paymentMethod,
    resetPaymentMethod,
  },
  ref,
) => {
  const dispatch = useDispatch();
  const axiosInstance = useAxios();
  const [saveCard, setSaveCard] = useState(false);
  const user = useSelector((state) => state.user);

  const payzenCreditCards =
    useSelector((state) => state.user.payzenCreditCards) || {};
  const payzenConecsCreditCards =
    useSelector((state) => state.user.payzenConecsCreditCards) || {};
  const isCBChecked = paymentMethod === 'cb';
  const isCONECSChecked = paymentMethod === 'conecs';
  const { store } = useSelector((state) => state.store);

  const deletePayzenCreditCard = (payzenCreditCards, paymentNetwork) => {
    dispatch(updatePayzenCards(payzenCreditCards, paymentNetwork));
    resetPaymentMethod();
    alert('Rafraichissement de la page pour mettre à jour les paiements');
    window.location.reload();
    // setIsContentVisible(false);
  };

  const handleDeletePayzenCreditCard = (paymentNetwork) => {
    let payzenCard;
    if (paymentNetwork === 'cb') payzenCard = payzenCreditCards;
    else payzenCard = payzenConecsCreditCards;
    if (!user._id) {
      deletePayzenCreditCard([], paymentNetwork);
      return;
    }

    axiosInstance
      .put('/payzen/delete-card', {
        paymentMethodToken: payzenCard[0].pm,
        userId: user._id,
        paymentNetwork,
      })
      .then((response) => {
        deletePayzenCreditCard(response.data.payzenCreditCards, paymentNetwork);
      })
      .catch((error) => {
        deletePayzenCreditCard(payzenCard[0], paymentNetwork);
        console.log({ error });
      });
  };

  const handleCheckboxChange = () => {
    onCheckboxChange();
  };

  const handleSaveCard = (state) => {
    let checkbox = document.querySelector('.checkbox');
    if (state.target.checked) {
      checkbox.classList.add('checked_svg');
    } else {
      checkbox.classList.remove('checked_svg');
    }
    setSaveCard(!saveCard);
  };
  const { checkoutState } = useCheckout();
  const payzen = checkoutState?.payzen?.token;

  const cart = useSelector((state) => state.cart);
  const { cartItems } = cart;
  const [payzenTokenForm, setPayzenTokenForm] = useState();
  const [payzenLoading, setPayzenLoading] = useState(true);
  const [payzenError, setPayzenError] = useState(false);

  const onPayzenInitialized = (token) => {
    setPayzenTokenForm(token);
    setPayzenLoading(false);
  };

  const onPayzenError = (errorMessage) => {
    setPayzenError(errorMessage);
  };

  const onPaymentLoading = (event) => {
    if (document.querySelector('.kr-payment-button')) {
      if (event === true) {
        document.querySelector('.kr-payment-button').innerHTML =
          `<p>Chargement ...</p> `;
      } else {
        document.querySelector('.kr-payment-button').innerHTML =
          `<p>Payer maintenant</p> ${formatPriceWithEuro(calculateTotalToPay(order.itemsPrice, order.promoPrice, order?.jackpot?.amount))}`;
      }
    }
  };

  const setTRpopup = () => {
    setApplepayTRpopup(true);
  };

  const handleSubmit = async () => {
    const email = getUserEmail(user);
    axiosInstance
      .post('/payzen/pay', {
        amount: calculateTotalToPay(order.itemsPrice, order.promoPrice, order?.jackpot?.amount),
        orderId: cartItems._id,
        storeId: cartItems.storeId,
        userEmail: email,
        user: user,
        paymentMethod: paymentMethod,
        // payzenCreditCards: payzenCreditCards[0]
      })
      .then((response) => {
        console.log('handleSubmit payzen payments /payzen/pay', response);
        if (response.data.status === 'succeeded') {
          dispatch(successPaidOrder(response.data));
          dispatch(addUsedPromo(user, axiosInstance, cartItems));
        } else {
          setPayzenError('Paiement échoué');
        }
      })
      .catch((error) => {
        console.log('handleSubmit payzen payments error /payzen/pay', error);
        sentryPspError(
          error?.response?.data?.payzenResponse?.transactions?.[0]
            ?.errorMessage ||
            error?.response?.data?.message ||
            'Paiement échoué',
          'payzen',
          `${
            user?.payzenCreditCards &&
            user?.payzenCreditCards?.[0]?.pm &&
            user.payzenCreditCards?.[0]?.pm?.length > 0
              ? 'cb payzen enregistrée'
              : 'cb payzen non enregistrée'
          }`,
        );
        error?.response?.data?.payzenResponse?.transactions?.[0]?.errorMessage
          ? errorMessage(
              error?.response?.data?.payzenResponse?.transactions?.[0]
                ?.errorMessage,
            )
          : errorMessage('Paiement échoué');
      });
  };

  useImperativeHandle(ref, () => ({
    handleSubmit,
  }));



  return (
    <div className="flex flex-col">
      <PayzenInit
        onPayzenInitialized={onPayzenInitialized}
        onPayzenError={onPayzenError}
        onPaymentLoading={onPaymentLoading}
        order={order}
        promoLoaded={promoLoaded}
        setPayzenToken={setPayzenToken}
        setTRpopup={setTRpopup}
        store={store}
      />
      {payzenCreditCards && payzenCreditCards[0]?.last4 ? (
        <div className="flex items-center formcarte text-black px-8 w-full">
          <div className="flex w-full" onClick={() => onCheckboxChange('cb')}>
            <input
              type="checkbox"
              checked={isCBChecked}
              id="choicecb"
              onChange={() => onCheckboxChange('cb')}
              className="hidden"
            />
            <label className="cbchecklabel mr-4"></label>
            <div className="flex flex-row gap-8 items-center">
              <img
                className="h-10 rounded-[5px] mr-2 "
                src={payzenCreditCards[0].img}
              />
              <div className="text-xl">.... {payzenCreditCards[0].last4} </div>
            </div>
          </div>
          <button
            onClick={() => handleDeletePayzenCreditCard('cb')}
            className="deletepayment"
            style={{ marginLeft: 'auto' }}
          >
            <img src={dell} alt="" />
          </button>
        </div>
      ) : (
        <>
          <div
            onClick={() => onCheckboxChange('cb')}
            className={`flex items-center formcarte text-black px-8 w-full order-1 !h-24 ${isCBChecked ? 'slide-down-btn open' : ''}`}
          >
            <div className="cbandlabel flex w-full">
              <div className="flex w-[70%] items-center">
                <input
                  id="cbCheckbox"
                  name="cbCheckboxview"
                  type="checkbox"
                  checked={isCBChecked}
                  onChange={() => onCheckboxChange('cb')}
                />
                <label
                  className="cbchecklabel mr-4"
                  onClick={() => onCheckboxChange('cb')}
                />
                <p
                  className="text-[16px]"
                  style={{ fontFamily: 'geomanistRegular' }}
                >
                  Carte bancaire
                </p>
              </div>
              <div className="cbimg flex gap-2 no-wrap flex items-center">
                <img
                  className="h-6 rounded-[5px"
                  src="https://storage.googleapis.com/pikkopay_images/webapp/payment/swile.png"
                />
                <img
                  className="h-16"
                  src="https://storage.googleapis.com/pikkopay_images/webapp/payment/visa.png"
                />
                <img
                  className="h-16"
                  src="https://storage.googleapis.com/pikkopay_images/webapp/payment/mastercard.png"
                />
              </div>
            </div>
          </div>
          <div
            className={`${isCBChecked ? 'order-2' : isCONECSChecked ? 'order-3' : ''}`}
          >
            <div
              id="cbpopup"
              style={{ fontFamily: 'Open Sans' }}
              className={`slide-down-transition ${
                (isCBChecked &&
                  (!payzenCreditCards || !payzenCreditCards[0]?.last4)) ||
                (isCONECSChecked &&
                  (!payzenConecsCreditCards ||
                    !payzenConecsCreditCards[0]?.last4))
                  ? 'slide-down-content visible '
                  : 'slide-down-content'
              }`}
            >
              <input
                className="mr-4"
                id="cbcheckbox"
                type="checkbox"
                checked={saveCard}
                onChange={handleSaveCard}
              />
              <div
                className="kr-smart-form"
                kr-payment-method="CARDS,CONECS"
              ></div>
              {payzenError && (
                <div className="kr-custom-error">{payzenError}</div>
              )}
            </div>
          </div>
        </>
      )}
      {store?.TR_CONECS && store?.TR_EDENRED && calculateTotalToPay(order.itemsPrice, order.promoPrice, order?.jackpot?.amount) >= 1.5 && (
        <>
          {payzenConecsCreditCards &&
          payzenConecsCreditCards[0]?.last4 &&
          store?.TR_CONECS ? (
            <div className="flex items-center formcarte text-black px-8 w-full">
              <div className="flex w-full">
                <input
                  id="cbCheckbox"
                  name="cbCheckboxview"
                  type="checkbox"
                  checked={isCONECSChecked}
                  onChange={() => {
                    handleCheckboxChange();
                    // toggleAccordion();
                  }}
                />
                <label
                  className="cbchecklabel mr-4"
                  onClick={() => onCheckboxChange('conecs')}
                ></label>
                <div className="flex flex-row items-end gap-8 items-center">
                  <img
                    className="h-10 rounded-[5px] mr-2 "
                    src={payzenConecsCreditCards[0].img}
                  />
                  <div className="text-xl">
                    .... {payzenConecsCreditCards[0].last4}{' '}
                  </div>
                </div>
              </div>
              <button
                onClick={() => handleDeletePayzenCreditCard('conecs')}
                className="deletepayment"
                style={{ marginLeft: 'auto' }}
              >
                <img src={dell} alt="" />
              </button>
            </div>
          ) : (
            <>
              <button
                onClick={() => onCheckboxChange('conecs')}
                disabled={!store?.TR_CONECS}
                className={`flex items-center formcarte text-black px-8 w-full !h-24 
              ${isCONECSChecked ? 'slide-down-btn open order-2' : isCBChecked ? 'order-3' : 'order-2'}`}
              >
                <div className="cbandlabel flex w-full">
                  <div className="flex w-[70%] items-center">
                    {store?.TR_CONECS && (
                      <>
                        <input
                          id="cbCheckbox"
                          name="cbCheckboxview"
                          type="checkbox"
                          checked={isCONECSChecked}
                          onChange={() => onCheckboxChange('conecs')}
                          disabled={!store?.TR_CONECS}
                        />
                        <label
                          className="cbchecklabel mr-4"
                          onClick={() => onCheckboxChange('conecs')}
                          disabled={!store?.TR_CONECS}
                        />
                      </>
                    )}

                    <p
                      className="text-[16px] flex text-start"
                      style={{ fontFamily: 'geomanistRegular' }}
                    >
                      {!store?.TR_CONECS
                        ? 'Bientôt disponible'
                        : 'Ticket restaurant'}
                    </p>
                  </div>
                  <div className="cbimg flex gap-2 no-wrap">
                    <img
                      className="h-16 rounded-[5px]"
                      src="https://storage.googleapis.com/pikkopay_images/webapp/payment/bimpli.png"
                    />
                    <img
                      className="h-16"
                      src="https://storage.googleapis.com/pikkopay_images/webapp/payment/pluxee.png"
                    />
                    <img
                      className="h-16"
                      src="https://storage.googleapis.com/pikkopay_images/webapp/payment/up.png"
                    />
                  </div>
                </div>
              </button>
              <div
                className={`${isCBChecked ? 'order-2' : isCONECSChecked ? 'order-3' : ''}`}
              >
                <div
                  id="cbpopup"
                  style={{ fontFamily: 'Open Sans' }}
                  className={`slide-down-transition ${
                    (isCBChecked &&
                      (!payzenCreditCards || !payzenCreditCards[0]?.last4)) ||
                    (isCONECSChecked &&
                      (!payzenConecsCreditCards ||
                        !payzenConecsCreditCards[0]?.last4))
                      ? 'slide-down-content visible '
                      : 'slide-down-content'
                  }`}
                >
                  <input
                    className="mr-4"
                    id="cbcheckbox"
                    type="checkbox"
                    checked={saveCard}
                    onChange={handleSaveCard}
                    disabled={!store?.TR_CONECS}
                  />
                  {payzenCreditCards && payzenCreditCards[0]?.last4 && (
                    <>
                      <div
                        className="kr-smart-form"
                        kr-payment-method="CARDS,CONECS"
                      ></div>
                      {payzenError && (
                        <div className="kr-custom-error">{payzenError}</div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default forwardRef(PayzenPayments);
